export default {
  common: {
    app_name: 'IoT',
    loading: 'Đang tải...',
    save: 'Lưu',
    saving: 'Đang lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    filters: 'Bộ lọc',
    resetFilters: 'Đặt lại bộ lọc',
    language: 'Ngôn ngữ',
    logout: 'Đăng xuất',
    error: 'Lỗi',
    success: 'Thành công',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    required_field: 'Trường này là bắt buộc',
    yes: 'Có',
    no: 'Không',
    back: 'Quay lại',
    view_all: 'Xem tất cả',
    view: 'Xem',
    select: 'Chọn một tùy chọn',
    profile: 'Hồ sơ',
    signOut: 'Đăng xuất',
    details: 'Chi tiết',
    tryAgain: 'Thử lại',
    create: 'Tạo mới',
    update: 'Cập nhật',
    refresh: 'Làm mới',
    actions: 'Thao tác',
    sortBy: 'Sắp xếp theo',
    sortDirection: 'Hướng sắp xếp',
    ascending: 'Tăng dần',
    descending: 'Giảm dần',
    perPage: 'Số dòng mỗi trang',
    dismiss: 'Bỏ qua',
    createTime: 'Thời gian tạo',
    lastUpdate: 'Cập nhật lần cuối',
    all: 'Tất cả',
    previous: 'Trước',
    next: 'Tiếp',
    quickActions: 'Thao tác nhanh',
    somethingWentWrong: 'Đã xảy ra lỗi',
    showing: 'Hiển thị',
    to: 'đến',
    of: 'trong tổng số',
    results: 'kết quả',
    unexpectedError: 'Đã xảy ra lỗi không mong muốn',
    hours: 'giờ',
    other: 'Khác',
    pagination: {
      showing: 'Hiển thị',
      to: 'đến',
      of: 'của',
      results: 'kết quả',
      page: 'Trang',
      nextPage: 'Trang tiếp theo',
      previousPage: 'Trang trước đó'
    }
  },
  devices: {
    statusOnline: 'Trực tuyến',
    statusOffline: 'Ngoại tuyến',
    refreshSuccess: 'Đã làm mới danh sách thiết bị thành công',
    statusMaintenance: 'Bảo trì',
    statistics: 'Thống kê thiết bị',
    lastChecked: 'Kiểm tra lần cuối:',
    backToDevices: 'Quay lại Thiết bị',
    stats: {
      cpu: 'CPU',
      memory: 'RAM',
      swap: 'Swap',
      disk: 'Lưu trữ',
      temperature: 'Nhiệt độ',
      noStatistics: 'Không có thống kê nào',
      power: 'Nguồn điện',
      powerGoodText: 'Tốt',
      powerBadText: 'Cần kiểm tra',
      network: 'Mạng',
      sdcardGoodText: 'Tốt',
      sdcardBadText: 'Cần kiểm tra',
    },
    management: 'Quản lý thiết bị',
    managementDescription: 'Danh sách tất cả thiết bị IoT trong mạng của bạn bao gồm trạng thái và vị trí của chúng.',
    addNew: 'Thêm thiết bị mới',
    createNew: 'Tạo thiết bị mới',
    createDescription: 'Thêm một thiết bị mới vào mạng IoT của bạn với thông tin sau.',
    edit: 'Chỉnh sửa thiết bị',
    editDevice: 'Chỉnh sửa thiết bị',
    editDescription: 'Chỉnh sửa thông tin chi tiết và cấu hình thiết bị.',
    name: 'Tên thiết bị',
    type: 'Loại thiết bị',
    location: 'Vị trí',
    serialNumber: 'Số sê-ri',
    lastSeen: 'Lần cuối truy cập',
    actions: 'Thao tác',
    descriptionHelp: 'Thêm thông tin bổ sung về thiết bị này, mục đích hoặc cấu hình của nó.',
    noDevicesAvailable: 'Không có thiết bị nào',
    deviceNotFound: 'Không tìm thấy thiết bị',
    deviceInformation: 'Thông tin thiết bị',
    deviceDetails: 'Thông tin chi tiết về thiết bị này và trạng thái hiện tại của nó.',
    setOnline: 'Đặt trực tuyến',
    setOffline: 'Đặt ngoại tuyến',
    basicDetails: 'Thông tin cơ bản và cấu hình',
    information: 'Thông tin thiết bị',
    selectType: 'Chọn loại',
    selectStatus: 'Chọn trạng thái',
    typeTemperature: 'Nhiệt độ',
    typeHumidity: 'Độ ẩm',
    typeLight: 'Ánh sáng',
    typeMotion: 'Chuyển động',
    typeSwitch: 'Công tắc',
    typeOther: 'Khác',
    confirmDelete: 'Xác nhận xóa',
    deleteWarning: 'Bạn có chắc chắn muốn xóa thiết bị này? Hành động này không thể hoàn tác.',
    title: 'Thiết bị',
    description: 'Quản lý thiết bị IoT và cấu hình của chúng',
    addDevice: 'Thêm thiết bị',
    namePlaceholder: 'Nhập tên thiết bị',
    ipAddress: 'Địa chỉ IP',
    ipAddressPlaceholder: 'Nhập địa chỉ IP (ví dụ: 192.168.1.100)',
    ipAddressHelp: 'Địa chỉ IP nơi thiết bị này có thể truy cập được trên mạng của bạn',
    ipAddressInvalid: 'Vui lòng nhập địa chỉ IP hợp lệ',
    ipAddressRequired: 'Địa chỉ IP là bắt buộc',
    ipAddressTooLong: 'Địa chỉ IP quá dài',
    nameRequired: 'Tên thiết bị là bắt buộc',
    nameTooLong: 'Tên thiết bị quá dài',
    statusRequired: 'Trạng thái là bắt buộc',
    statusInvalid: 'Giá trị trạng thái không hợp lệ',
    statusInactive: 'Không hoạt động',
    statusActive: 'Đang hoạt động',
    statusShutdown: 'Đã tắt',
    statusInactiveDescription: 'Thiết bị đã đăng ký nhưng không được giám sát tích cực',
    statusActiveDescription: 'Thiết bị đang trực tuyến và được giám sát',
    statusShutdownDescription: 'Thiết bị tạm thời bị vô hiệu hóa',
    deviceInactive: 'Thiết bị này hiện không hoạt động',
    deviceInactiveDescription: 'Kích hoạt thiết bị này để bật tính năng giám sát và điều khiển',
    deviceShutdown: 'Thiết bị này đã tắt',
    deviceShutdownDescription: 'Thiết bị này đã tạm thời bị vô hiệu hóa',
    noDevices: 'Không có thiết bị',
    noDevicesDescription: 'Bắt đầu bằng cách thêm thiết bị IoT đầu tiên của bạn',
    deactivate: 'Hủy kích hoạt',
    activate: 'Kích hoạt',
    addDeviceDescription: 'Thêm một thiết bị mới vào mạng IoT của bạn',
    editDeviceDescription: 'Sửa đổi cài đặt cho thiết bị này',
    deleteDevice: 'Xóa thiết bị',
    deleteConfirmation: 'Bạn có chắc chắn muốn xóa {name}? Hành động này không thể hoàn tác.',
    statusUnknown: 'Không xác định',
    refreshDevices: 'Làm mới thiết bị',
    create: {
      title: 'Tạo thiết bị mới',
      error: 'Không thể tạo thiết bị'
    },
    fields: {
      name: 'Tên thiết bị',
      ipAddress: 'Địa chỉ IP',
      status: 'Trạng thái'
    },
    status: {
      title: 'Trạng thái',
      inactive: 'Không hoạt động',
      active: 'Đang hoạt động',
      shutdown: 'Đã tắt'
    },
    schedules: {
      title: 'Lịch cho Linh kiện',
      description: 'Quản lý lịch cho linh kiện này',
      add: 'Thêm lịch',
      edit: 'Chỉnh sửa lịch',
      delete: 'Xóa lịch',
      confirmDelete: 'Bạn có chắc chắn muốn xóa lịch này?',
      noSchedules: 'Không tìm thấy lịch nào cho linh kiện này',
      stateSources: {
        schedule: 'Theo lịch',
        manual: 'Ghi đè thủ công',
        default: 'Mặc định'
      },
      override: {
        title: 'Ghi đè thủ công',
        apply: 'Áp dụng ghi đè',
        change: 'Thay đổi ghi đè',
        remove: 'Xóa ghi đè',
        types: {
          until_next_schedule: 'Cho đến lịch tiếp theo',
          duration: 'Trong khoảng thời gian',
          until_time: 'Đến thời điểm cụ thể',
          permanent: 'Vĩnh viễn (Cho đến khi xóa thủ công)'
        }
      }
    }
  },
  readings: {
    temperature: 'Nhiệt độ',
    humidity: 'Độ ẩm',
    pressure: 'Áp suất',
    motion: 'Chuyển động',
    light: 'Ánh sáng',
    battery: 'Pin',
    lastReading: 'Chỉ số gần đây',
    recentReadings: 'Chỉ số gần đây',
    unit: 'Đơn vị',
    value: 'Giá trị',
    timestamp: 'Thời gian',
    noReadingsAvailable: 'Không có chỉ số nào'
  },
  dashboard: {
    title: 'Bảng điều khiển',
    welcome: 'Xin chào',
    activeDevices: 'Thiết bị đang hoạt động',
    totalReadings: 'Tổng số chỉ số',
    deviceStatus: 'Trạng thái thiết bị',
    sensorReadings: 'Chỉ số cảm biến (7 ngày gần đây)',
    noDevicesAvailable: 'Không có thiết bị nào',
    noReadingsAvailable: 'Không có chỉ số nào',
    description: 'Tổng quan về mạng IoT và trạng thái thiết bị của bạn',
    coming_soon: 'Tính năng bảng điều khiển sắp ra mắt'
  },
  home: {
    hero: {
      title: 'Nền tảng IoT thông minh để quản lý thiết bị',
      subtitle: 'Giám sát và điều khiển thiết bị IoT của bạn với trực quan hóa dữ liệu thời gian thực và tính năng tự động hóa thông minh.',
      getStarted: 'Bắt đầu miễn phí',
      login: 'Đăng nhập'
    },
    features: {
      title: 'Tại sao chọn nền tảng IoT của chúng tôi',
      subtitle: 'Nền tảng của chúng tôi cung cấp mọi thứ bạn cần để quản lý và giám sát thiết bị IoT của bạn một cách hiệu quả.',
      realTimeTracking: {
        title: 'Giám sát thời gian thực',
        description: 'Cập nhật với dữ liệu thời gian thực từ tất cả các thiết bị và cảm biến kết nối của bạn với thông báo tức thì.'
      },
      transactionHistory: {
        title: 'Tự động hóa thông minh',
        description: 'Tạo quy tắc tùy chỉnh và quy trình tự động hóa để điều khiển thiết bị của bạn dựa trên dữ liệu cảm biến và lịch trình.'
      },
      portfolioAnalytics: {
        title: 'Phân tích dữ liệu',
        description: 'Có được thông tin hữu ích từ dữ liệu thiết bị của bạn với phân tích toàn diện và bảng điều khiển tùy chỉnh.'
      }
    },
    deviceTypes: {
      title: 'Thiết bị được hỗ trợ',
      subtitle: 'Nền tảng của chúng tôi hoạt động với nhiều loại thiết bị IoT và cảm biến cho các ứng dụng khác nhau.',
      deviceType: 'Loại thiết bị',
      connectivity: 'Kết nối',
      applications: 'Ứng dụng',
      getStartedCta: 'Bắt đầu với thiết bị của bạn'
    },
    howItWorks: {
      title: 'Cách hoạt động',
      subtitle: 'Bắt đầu với nền tảng IoT của chúng tôi chỉ với một vài bước đơn giản',
      step1: {
        title: 'Tạo tài khoản',
        description: 'Đăng ký tài khoản miễn phí chỉ với email và mật khẩu của bạn để bắt đầu.'
      },
      step2: {
        title: 'Kết nối thiết bị',
        description: 'Thêm thiết bị IoT và cảm biến tương thích của bạn vào nền tảng với trình hướng dẫn thiết lập đơn giản của chúng tôi.'
      },
      step3: {
        title: 'Cấu hình thiết lập',
        description: 'Thiết lập tham số giám sát tùy chỉnh và cảnh báo dựa trên yêu cầu cụ thể của bạn.'
      },
      step4: {
        title: 'Giám sát & Điều khiển',
        description: 'Truy cập bảng điều khiển cá nhân của bạn để xem dữ liệu thời gian thực và điều khiển các thiết bị đã kết nối của bạn.'
      }
    },
    cta: {
      title: 'Sẵn sàng tự động hóa và tối ưu hóa môi trường IoT của bạn?',
      subtitle: 'Tham gia cùng hàng nghìn người dùng tin tưởng nền tảng của chúng tôi để quản lý thiết bị IoT của họ và tạo ra môi trường thông minh hơn.',
      createAccount: 'Tạo tài khoản miễn phí',
      signIn: 'Đăng nhập'
    },
    footer: {
      description: 'Nền tảng IoT thông minh để giám sát và điều khiển các thiết bị kết nối của bạn với trực quan hóa dữ liệu thời gian thực.',
      quickLinks: 'Liên kết nhanh',
      resources: 'Tài nguyên',
      documentation: 'Tài liệu',
      api: 'Tham khảo API',
      support: 'Hỗ trợ',
      contact: 'Liên hệ',
      email: "nguyenductoan2405{'@'}gmail.com",
      phone: '(+84) 987 802 175',
      copyright: 'Tất cả các quyền được bảo lưu.'
    }
  },
  auth: {
    login: 'Đăng nhập',
    register: 'Đăng ký',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    confirm_password: 'Xác nhận mật khẩu',
    name: 'Họ tên',
    forgot_password: 'Quên mật khẩu?',
    no_account: 'Chưa có tài khoản?',
    has_account: 'Đã có tài khoản?',
    create_account: 'Tạo tài khoản',
    invalid_credentials: 'Tên đăng nhập hoặc mật khẩu không hợp lệ',
    logout_success: 'Bạn đã đăng xuất thành công',
    password_mismatch: 'Mật khẩu không khớp',
    registration_success: 'Đăng ký thành công! Bạn có thể đăng nhập ngay bây giờ.',
    remember_me: 'Ghi nhớ đăng nhập',
    password_requirements: 'Mật khẩu phải có ít nhất 6 ký tự'
  },
  profile: {
    title: 'Hồ sơ',
    personal_info: 'Thông tin cá nhân',
    change_password: 'Đổi mật khẩu',
    current_password: 'Mật khẩu hiện tại',
    new_password: 'Mật khẩu mới',
    confirm_new_password: 'Xác nhận mật khẩu mới',
    update_profile: 'Cập nhật hồ sơ',
    update_password: 'Cập nhật mật khẩu',
    profile_updated: 'Hồ sơ đã được cập nhật thành công',
    password_updated: 'Mật khẩu đã được cập nhật thành công',
    incorrect_password: 'Mật khẩu hiện tại không chính xác',
    password_must_be_different: 'Mật khẩu mới phải khác với mật khẩu hiện tại'
  },
  errors: {
    something_went_wrong: 'Đã xảy ra lỗi',
    network_error: 'Lỗi mạng. Vui lòng kiểm tra kết nối của bạn và thử lại.',
    unauthorized: 'Bạn không được phép truy cập tài nguyên này',
    session_expired: 'Phiên của bạn đã hết hạn. Vui lòng đăng nhập lại.',
    validation_error: 'Vui lòng kiểm tra biểu mẫu để tìm lỗi',
    not_found: 'Không tìm thấy tài nguyên được yêu cầu'
  },
  languages: {
    en: 'Tiếng Anh',
    vi: 'Tiếng Việt'
  },
  components: {
    management: 'Quản lý thành phần',
    forDevice: 'Thành phần cho',
    viewAll: 'Xem tất cả thành phần',
    clickToViewAll: 'Nhấp để xem tất cả thành phần cho thiết bị này',
    title: 'Thành phần thiết bị',
    manageComponents: 'Quản lý thành phần thiết bị và cấu hình của chúng',
    addComponent: 'Thêm thành phần',
    noComponents: 'Không có thành phần',
    noComponentsDescription: 'Thiết bị này chưa có thành phần nào',
    data: 'Dữ liệu',
    details: 'Chi tiết thành phần',
    id: 'ID thành phần',
    deviceId: 'ID thiết bị',
    backToComponents: 'Quay lại thành phần',
    unableToDisplay: 'Không thể hiển thị thành phần',
    loadingError: 'Đã xảy ra sự cố khi tải dữ liệu thành phần. Vui lòng thử làm mới trang.',
    editComponent: 'Chỉnh sửa thành phần',
    deleteComponent: 'Xóa thành phần',
    deleteConfirmation: 'Bạn có chắc chắn muốn xóa thành phần này? Hành động này không thể hoàn tác.',
    addComponentDescription: 'Thêm thành phần mới cho thiết bị này.',
    editComponentDescription: 'Cập nhật thông tin và cài đặt thành phần.',
    componentName: 'Tên thành phần',
    componentType: 'Loại thành phần',
    initialStatus: 'Trạng thái ban đầu',
    preview: 'Xem trước',
    status: 'Trạng thái',
    cameraStreamUrl: 'URL luồng camera',
    cameraStreamUrlHelp: 'Nhập URL cho luồng camera (RTSP, HLS hoặc URL iframe nhúng)',
    sensorData: 'Dữ liệu cảm biến',
    sensorDataHelp: 'Nhập chỉ số hoặc dữ liệu cảm biến hiện tại',
    displayType: 'Loại hiển thị',
    content: 'Nội dung',
    typeCannotBeChanged: 'Loại thành phần không thể thay đổi sau khi tạo.',
    actuatorType: 'Loại cơ cấu chấp hành',
    position: 'Vị trí',
    inputType: 'Loại đầu vào',
    mode: 'Chế độ',
    pin: 'Số chân',
    pinHelp: 'Số chân vật lý trên thiết bị',
    modeDigital: 'Kỹ thuật số',
    modeAnalog: 'Tương tự',
    otherComponentSettings: 'Cài đặt thành phần bổ sung',
    digitalValue: 'Giá trị kỹ thuật số',
    analogValue: 'Giá trị tương tự',
    currentReading: 'Chỉ số hiện tại',
    noDataAvailable: 'Không có dữ liệu',
    lastUpdated: 'Cập nhật lần cuối',
    streamPreview: 'Xem trước luồng',
    noPreview: 'Không có bản xem trước',
    relayState: {
      on: 'Bật',
      off: 'Tắt'
    },
    schedules: {
      title: 'Lịch trình thành phần',
      description: 'Quản lý lịch trình cho thành phần này',
      add: 'Thêm lịch trình',
      edit: 'Chỉnh sửa lịch trình',
      delete: 'Xóa lịch trình',
      confirmDelete: 'Bạn có chắc chắn muốn xóa lịch trình này?',
      name: 'Tên',
      cronExpression: 'Biểu thức Cron',
      cronExpressionHelp: 'Thời gian lịch trình sử dụng cú pháp cron (ví dụ: * * * * *)',
      cronTranslation: 'Dịch biểu thức cron',
      actionData: 'Dữ liệu hành động',
      actionDataHelp: 'Dữ liệu JSON đại diện cho hành động cần thực hiện',
      priority: 'Ưu tiên',
      priorityHelp: 'Lịch trình có ưu tiên cao hơn sẽ được ưu tiên khi nhiều lịch trình kích hoạt cùng lúc',
      status: 'Trạng thái',
      addSuccess: 'Đã thêm lịch trình thành công',
      updateSuccess: 'Đã cập nhật lịch trình thành công',
      deleteSuccess: 'Đã xóa lịch trình thành công',
      saving: 'Đang lưu...',
      deleting: 'Đang xóa...',
      humanReadable: 'Mô tả dễ đọc',
      activeLabel: 'Đang hoạt động',
      statusActive: 'Đang hoạt động',
      statusInactive: 'Không hoạt động',
      active: 'Hoạt động',
      inactive: 'Không hoạt động', 
      statusHelp: 'Lịch trình chỉ chạy khi đang hoạt động',
      cronRequired: 'Biểu thức cron là bắt buộc',
      actionDataRequired: 'Dữ liệu hành động là bắt buộc',
      invalidCron: 'Biểu thức cron không hợp lệ',
      invalidActionData: 'Dữ liệu hành động không hợp lệ (phải là JSON hợp lệ)',
      nextScheduleAt: 'Thay đổi lịch trình tiếp theo lúc:',
      noScheduleFound: 'Không có thay đổi lịch trình sắp tới',
      currentState: 'Trạng thái hiện tại',
      stateSource: 'Nguồn trạng thái',
      manualOverrideUntil: 'Ghi đè thủ công đến',
      nextScheduleTime: 'Lịch trình tiếp theo',
      currentStateData: 'Dữ liệu trạng thái hiện tại',
      createTitle: 'Tạo lịch trình mới',
      editTitle: 'Chỉnh sửa lịch trình',
      nameLabel: 'Tên (tùy chọn)',
      namePlaceholder: 'Tên lịch trình',
      scheduleType: 'Loại lịch trình',
      dailyTime: 'Thời gian hàng ngày',
      timeLabel: 'Thời gian',
      actionLabel: 'Hành động',
      actionPlaceholder: 'Hành động cần thực hiện',
      deleteSchedule: 'Xóa lịch trình',
      deleteConfirmation: 'Bạn có chắc chắn muốn xóa lịch trình này? Hành động này không thể hoàn tác.',
      cronFormat: 'Định dạng: phút giờ ngày-trong-tháng tháng ngày-trong-tuần',
      addNewSchedule: 'Thêm lịch trình mới',
      editSchedule: 'Chỉnh sửa lịch trình',
      noSchedules: 'Không có lịch trình',
      getStarted: 'Bắt đầu bằng cách tạo một lịch trình mới.',
      cronTooComplex: 'Biểu thức cron này quá phức tạp cho thời gian hàng ngày',
      stateSources: {
        schedule: 'Theo lịch trình',
        manual: 'Ghi đè thủ công',
        default: 'Mặc định'
      },
      override: {
        title: 'Ghi đè thủ công',
        description: 'Tạm thời ghi đè hành vi đã lên lịch của thành phần này',
        apply: 'Áp dụng ghi đè',
        change: 'Thay đổi ghi đè',
        remove: 'Xóa ghi đè',
        applying: 'Đang áp dụng...',
        removing: 'Đang xóa...',
        success: 'Đã áp dụng ghi đè thành công',
        removeSuccess: 'Đã xóa ghi đè thành công',
        duration: 'Thời lượng',
        selectDuration: 'Chọn thời lượng',
        durationMinutes: 'Thời lượng (phút)',
        untilDateTime: 'Đến ngày/giờ',
        selectDateTime: 'Chọn ngày và giờ',
        overrideData: 'Dữ liệu ghi đè (JSON)',
        overrideDataPlaceholder: 'Nhập dữ liệu JSON',
        invalidData: 'Dữ liệu JSON không hợp lệ',
        dataRequired: 'Dữ liệu ghi đè là bắt buộc',
        overrideActive: 'Ghi đè thủ công đang hoạt động',
        overrideExpires: 'Ghi đè hết hạn:',
        confirmRemove: 'Bạn có chắc chắn muốn xóa ghi đè hiện tại?',
        types: {
          until_next_schedule: 'Đến lịch trình tiếp theo',
          duration: 'Trong khoảng thời gian',
          until_time: 'Đến thời điểm cụ thể',
          permanent: 'Vĩnh viễn (Cho đến khi xóa thủ công)'
        }
      }
    }
  }
}